export function initLoginRedirectCtas() {
  const membersOnlyBanner = document.querySelector('.members-only-banner-component');
  if (!membersOnlyBanner) return;

  const links = document.querySelectorAll('a[href]');

  links.forEach((link) => {
    const href = link.getAttribute('href');
    if (!href) return;

    let url;
    try {
      url = new URL(href, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    const pathname = url.pathname.replace(/\/$/, '');
    if (pathname !== '/login') return;

    if (url.searchParams.has('redirect_to')) return;

    url.searchParams.set('redirect_to', window.location.href);
    link.href = url.toString();
  });
}
